import React, { useEffect } from 'react';
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Grid,
  Button,
  CardActions,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getPartnersOnly } from '../../Redux/partnersRedux.js';
import { useNavigate } from 'react-router-dom';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const cardStyles = {
  card: {
    boxShadow: '0px 2px 4px 2px rgba(0, 0, 0, 0.25)',
    padding: '8px',
    marginBottom: '16px',
    cursor: 'pointer',
  },
  media: {
    height: '200px',
    objectFit: 'cover',
    // borderTopRightRadius: '100px',
    // borderBottomLeftRadius: '100px',
  },
  actions: {
    paddingTop: '8px',
    justifyContent: 'space-between',
  },
};

function Partners() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { allPartnersOnly } = useSelector((state) => state.partnersRedux);

  useEffect(() => {
    dispatch(getPartnersOnly());
  }, [dispatch]);

  const handleCardClick = (partner) => {
    const partnerId = partner._id;
    // dispatch(getProductById(partnerId));
    navigate(`/partnerInfo/${partnerId}`, { state: { partner } });
  };

  return (
    <div className='container my-5'>
      <div className='row d-flex align-items-center justify-content-center mb-4'>
        <div className='col-12 d-flex justify-content-center'>
          <h3 className='underline'>Our Entrepreneurs</h3>
        </div>
      </div>
      <Grid container spacing={4}>
        {allPartnersOnly && allPartnersOnly.length > 0 ? (
          allPartnersOnly.map((partner) => (
            <Grid item xs={12} sm={4} md={4} lg={4} key={partner.id}>
              <Card sx={cardStyles.card}>
                <CardMedia
                  component='img'
                  sx={cardStyles.media}
                  image={partner.images[0]?.image}
                  alt={partner.partnerName}
                />
                <CardContent>
                  <Typography gutterBottom variant='h5' component='div'>
                    {partner.partnerName}
                  </Typography>
                  <Typography variant='body2' color='text.secondary'>
                    {partner.description.split(' ').length > 10
                      ? `${partner.description
                          .split(' ')
                          .slice(0, 10)
                          .join(' ')}...`
                      : partner.description}
                  </Typography>
                  <Typography
                    variant='h6'
                    sx={{
                      color: 'text.primary',
                      mt: 1,
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <LocationOnIcon sx={{ mr: 1 }} />
                    {partner.location}
                  </Typography>
                </CardContent>
                <CardActions sx={cardStyles.actions}>
                  <Grid container>
                    <Grid item xs={12}>
                      <Button
                        sx={{
                          color: 'var(--primary-color)',
                          padding: 0,
                        }}
                        // startIcon={<ShoppingBagIcon />}
                        fullWidth
                        onClick={() => handleCardClick(partner)}
                      >
                        View Details
                      </Button>
                    </Grid>
                  </Grid>
                </CardActions>
              </Card>
            </Grid>
          ))
        ) : (
          <></>
          // <p>No entrepreneurs available</p>
        )}
      </Grid>
    </div>
  );
}

export default Partners;
